var ytbgloaded = 0;
$(document).on('scroll', function () {
    if (!ytbgloaded) {
        ytbgloaded = 1;

        $('[data-vbg]').youtube_background({ 'load-background': false });
    }
});